<div class="tabs">
  <button (click)="selectedDashboard = 'metabase'" [class.active]="selectedDashboard === 'metabase'">{{"GLOBAL.DASHBOARD_METABASE" | translate}}</button>
  <button (click)="selectedDashboard = 'acutal'" [class.active]="selectedDashboard === 'acutal'">{{"GLOBAL.DASHBOARD_ACTUAL" | translate}}</button>
</div>

<div class="tab-content">
  <div [hidden]="selectedDashboard !== 'metabase'" class="metabase-dashboard-container">
    @if (loadMetabase()) {
      <app-metabase-dashboard class="metabase-dashboard" componentSelector="app-dashboard"></app-metabase-dashboard>
    }
  </div>
  <div [hidden]="selectedDashboard !== 'acutal'" class="actual-dashboard-container">

    @if (dashboardVide()) {
      <div class="overlay-no-data row align-items-center">
        <div class="col">
          <i class="fas fa-chart-line fa-9x"></i>
          <p style="font-size:1.5em;color:#ccc">{{"GLOBAL.DASHBOARD_VIDE" | translate}}</p>
        </div>
      </div>
    }

    @if (!dashboardVide()) {
      <div class="dashboard">
        <div class="col-11" style="margin-top:2%; margin-bottom: 5%;">
          <ngx-loading [config]="{ fullScreenBackdrop: false, backdropBackgroundColour:'transparent' }" [show]="dataLoading()"></ngx-loading>
          @if (!erreurRecuperation()) {
            <div class="row">
              @for (chart of charts(); track chart; let i = $index) {
                @if (chart.data && chart.type != 'combinedChart') {
                  <div class="col-6" style="margin-bottom: 1%;">
                    <div class="card dashboard-card" [ngStyle]="{'height': graphiques()[i].nom ? '' : '46.3vh' }">
                      @if (graphiques()[i].nom) {
                        <div class="card-header">
                          {{graphiques()[i].nom}}
                          <button type="button" class="close" aria-label="Close" (click)="showConfirmSuppr(i)">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      }
                      @if (!graphiques()[i].nom) {
                        <button type="button" class="close" aria-label="Close" style="margin-right: 5px;" (click)="showConfirmSuppr(i)">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      }
                      <div class="chart-container" style="position: relative; height: 40vh; width: 100%; overflow: hidden;">
                        <canvas #chartCanvas [id]="'chart-' + i" style="display: block; width: 100%; height: 100%;"></canvas>
                      </div>
                    </div>
                  </div>
                }
                <!-- GRAPHIQUE COMBINE -->
                @if (chart.data && chart.type == 'combinedChart') {
                  <div class="col-12" style="margin-bottom: 1%;">
                    <div class="card dashboard-card">
                      @if (graphiques()[i].nom) {
                        <div class="card-header">
                          {{graphiques()[i].nom}}
                          <button type="button" class="close" aria-label="Close" (click)="showConfirmSuppr(i)">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      }
                      @if (!graphiques()[i].nom) {
                        <button type="button" class="close" aria-label="Close" style="margin-right: 5px;" (click)="showConfirmSuppr(i)">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      }
                      <div style="display: block; padding:10px;">
                        <div class="combined-chart-container">
                          <table class="combined-chart table-sm">
                            <thead style="font-size:.7em">
                              <tr>
                                <th class="first-th"></th>
                                @for (d of chart.data.datesDeTirs; track d) {
                                  <th scope="col">{{d | date: 'dd/MM/yyyy'}}</th>
                                }
                              </tr>
                            </thead>
                            <tbody>
                              @for (d of chart.data.lignes; track d; let i = $index) {
                                <tr [ngClass]="{'fond-bleu' : d.nomZone}">
                                  @if (d.nomZone) {
                                    <td class="td-zone">{{d.nomZone}}</td>
                                    <td colspan="100%"></td>
                                  }
                                  @if (d.nomProjet) {
                                    <td class="first-column">{{d.nomProjet}}</td>
                                    @for (data of d.datas; track data) {
                                      <td [ngStyle]="{'background-color': data.couleur}">{{data.val}}</td>
                                    }
                                  }
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          }
          @if (erreurRecuperation()) {
            <div class="custom-alert custom-alert-sm">
              {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
            </div>
          }
        </div>
      </div>
    }

    <div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-body text-center">
            <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
            <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
            <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
